import { type FormatDateOptions, useIntl } from 'react-intl';

import useSettings from './hooks/useSettings';
import { parseDate } from './Utils';

export default function FormattedDateTimeRange({
	from,
	to,
	displayDate = true,
	displayTime = false
}: {
	from?: string;
	to?: string;
	displayDate?: boolean;
	displayTime?: boolean;
}) {
	const { t } = useSettings();
	const intl = useIntl();

	const options: FormatDateOptions = {
		...(displayDate && { year: 'numeric', month: '2-digit', day: '2-digit' }),
		...(displayTime && { hour: '2-digit', minute: '2-digit', hour12: false })
	};

	const parsedFrom = parseDate(from);
	const parsedTo = parseDate(to);

	if (parsedFrom && parsedTo) {
		return intl.formatDateTimeRange(parsedFrom.toDate(), parsedTo.toDate(), options);
	}

	if (parsedFrom && !parsedTo) {
		return intl.formatDate(parsedFrom.toDate(), options);
	}

	if (!parsedFrom && parsedTo) {
		return intl.formatDate(parsedTo.toDate(), options);
	}

	return t('VIEW_ITEM_NO_DATES');
}
